/**
 * Cart Drawer Component
 */
(function () {
  "use strict";

  const CartDrawer = {
    type: "closed",
    hasOpened: false,

    init() {
      const cartToggle = document.querySelector("[data-cart-toggle]");
      const cartDrawer = document.querySelector("[data-cart-drawer]");
      const cartOverlay = document.querySelector("[data-cart-overlay]");
      const cartClose = document.querySelector("[data-cart-close]");
      const cartCloseOutside = document.querySelector(
        "[data-cart-close-outside]"
      );

      if (!cartDrawer || !cartOverlay) return;

      // Open cart
      if (cartToggle) {
        cartToggle.addEventListener("click", (e) => {
          e.preventDefault();
          this.open();
        });
      }

      // Close cart
      if (cartClose) {
        cartClose.addEventListener("click", () => this.close());
      }

      if (cartCloseOutside) {
        cartCloseOutside.addEventListener("click", () => this.close());
      }

      // Close on Escape key
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && this.type === "cart") {
          this.close();
        }
      });
    },

    open() {
      this.type = "cart";
      if (!this.hasOpened) {
        this.hasOpened = true;
        const overlay = document.querySelector("[data-cart-overlay]");
        if (overlay) overlay.classList.add("ready");
      }
      const overlay = document.querySelector("[data-cart-overlay]");
      if (overlay) overlay.classList.add("expanded");
    },

    close() {
      this.type = "closed";
      const overlay = document.querySelector("[data-cart-overlay]");
      if (overlay) overlay.classList.remove("expanded");
    },
  };

  window.CartDrawer = CartDrawer;
})();
